var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "global-selection mb-0 mb-sm-3"
  }, [_c('MdmLink', {
    staticClass: "global-link d-flex d-sm-block position-relative h-100 align-items-end",
    attrs: {
      "url": _vm.url
    }
  }, [_c('div', {
    staticClass: "global-selection-top"
  }, [_c('div', {
    staticClass: "selection-top-image lazyload bg-cover-center",
    attrs: {
      "data-bgset": _vm.src,
      "data-sizes": "auto"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "global-selection-bottom px-3 pt-1 pt-sm-3"
  }, [_c('p', {
    staticClass: "title font-weight-semibold mb-0",
    domProps: {
      "textContent": _vm._s(_vm.title.text)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cta mb-4",
    domProps: {
      "textContent": _vm._s(_vm.cta)
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "d-block d-sm-none mb-0 mx-0"
  })]), _vm._v(" "), _c('hr', {
    staticClass: "d-none d-sm-block my-0 mx-3 position-absolute"
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };